<template>
  <div class="wrap">
    <!-- <Header activeIndex="/workspace"/> -->

    <div class="bannerimg">
      <img src="@/assets/match/haibao.jpg" alt="" style="width: 100%" />
    </div>
    <div class="pagew content">
      <div class="flexbox">
        <div class="left">
          <div class="cont">
            本届大赛将举行"湾区共创设计坊(WORKSHOP)"为特色的大赛全程的产学研合作工作。大赛将整合东莞市企业、大湾区内高校和设计机构三方面的创新要素资源，以企业的实际设计需求，举行共创设计，以设计工作坊的形式，
            推进产学研的深度合作，为企业设计攻关、项目落地和大赛成果产业化提供保障。
          </div>
        </div>
        <div class="right">
          <div class="imgbox">
            <div class="each">
              <div>
                <img
                  src="@/assets/match/ftwo.png"
                  alt=""
                  style="width: 180px; height: 280px"
                />
              </div>
              <div class="title">
                <div class="info">东莞市企业</div>
                <div class="name">DONGGUAN ENTERPRISE</div>
              </div>
            </div>
          </div>
          <div class="imgbox">
            <div class="each">
              <div class="title">
                <div class="info">大湾区内高校</div>
                <div class="name" style="padding-bottom: 20px">
                  UNIVERSITIES IN DAWAN DISTRICT
                </div>
              </div>
              <div>
                <img
                  src="@/assets/match/fthree.png"
                  alt=""
                  style="width: 180px; height: 280px"
                />
              </div>
            </div>
          </div>
          <div class="imgbox">
            <div class="each">
              <div>
                <img
                  src="@/assets/match/fone.png"
                  alt=""
                  style="width: 180px; height: 280px"
                />
              </div>
              <div class="title">
                <div class="info">设计机构</div>
                <div class="name">DESIGN DEPARTMENT</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer class="workspace-footer" :show="true" />
  </div>
</template>

<script>
// import Footer from "@/components/Footer/index";
// import Header from "@/components/Header/Header";
export default {
  name: "workspace",
  // components: { Footer,Header },
};
</script>

<style scoped lang="scss">
.wrap {
  width: 100%;

  .bannerimg {
    z-index: -2;
  }

  .content {
    .flexbox {
      width: 100%;
      display: flex;
      .left {
        width: 20%;
        height: 650px;
        display: flex;
        align-items: center;
        background-color: #044fa6;
        .cont {
          text-align: justify;
          width: 85%;
          margin: 0 auto;
          color: #ffffff;
          line-height: 30px;
          font-size: 14px;
          font-weight: bold;
        }
      }
      .right {
        width: 80%;
        // height: 50vh;
        display: flex;
        margin-left: 50px;
        .imgbox {
          width: 33%;
          // height: 50vh;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;
          .each {
            width: 80%;
            .title {
              width: 80%;
              margin: 0 auto;
              text-align: left;
              color: #bc2020;
              font-weight: bold;
              .info {
                font-weight: 700;
                padding: 10px 0;
              }
              .name {
                font-size: 12px;
                color: #000000;
              }
            }
          }
        }
      }
    }
  }


}
</style>
<style lang="scss">
.workspace-footer.footerbox {
  margin-top: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/view/Match/workspace.vue